var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('span',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.error.message ? _vm.error.message : _vm.error))]),_vm._v(" "),_c('vbutton',{staticClass:"button",attrs:{"label":"responses.tags.distributionRules.refresh"},on:{"click":function($event){return _vm.$emit('reload')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }